module.exports = __webpack_public_path__ + "static/media/map_2_bzo_4.4b7036da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/library/widgets/map/assets/map_2_bzo_4.svg
// module id = 757
// module chunks = 0